// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/assertions.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { LatchState, latchStateFromJSON, latchStateToJSON } from "../assertions/assertion_types";
import { PathId } from "../schema_path/path_id";

export const protobufPackage = "configd";

export interface Assertion {
  /** The assertion path. */
  id:
    | PathId
    | undefined;
  /** The assertion latch state. */
  state: LatchState;
}

/** A response to latching one or more assertions. */
export interface AssertionsResponse {
  /** The list of assertions which were succesfully latched. */
  assertions: Assertion[];
}

/** Latch one or more assertions. */
export interface LatchAssertionsRequest {
  /** The list of assertions to be latched. */
  assertions: Assertion[];
  /** The fabric id or name. */
  fabricId: string;
}

function createBaseAssertion(): Assertion {
  return { id: undefined, state: 0 };
}

export const Assertion: MessageFns<Assertion> = {
  encode(message: Assertion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Assertion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Assertion {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      state: isSet(object.state) ? latchStateFromJSON(object.state) : 0,
    };
  },

  toJSON(message: Assertion): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.state !== 0) {
      obj.state = latchStateToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Assertion>, I>>(base?: I): Assertion {
    return Assertion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Assertion>, I>>(object: I): Assertion {
    const message = createBaseAssertion();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseAssertionsResponse(): AssertionsResponse {
  return { assertions: [] };
}

export const AssertionsResponse: MessageFns<AssertionsResponse> = {
  encode(message: AssertionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assertions) {
      Assertion.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assertions.push(Assertion.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionsResponse {
    return {
      assertions: globalThis.Array.isArray(object?.assertions)
        ? object.assertions.map((e: any) => Assertion.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AssertionsResponse): unknown {
    const obj: any = {};
    if (message.assertions?.length) {
      obj.assertions = message.assertions.map((e) => Assertion.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionsResponse>, I>>(base?: I): AssertionsResponse {
    return AssertionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionsResponse>, I>>(object: I): AssertionsResponse {
    const message = createBaseAssertionsResponse();
    message.assertions = object.assertions?.map((e) => Assertion.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLatchAssertionsRequest(): LatchAssertionsRequest {
  return { assertions: [], fabricId: "" };
}

export const LatchAssertionsRequest: MessageFns<LatchAssertionsRequest> = {
  encode(message: LatchAssertionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assertions) {
      Assertion.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatchAssertionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatchAssertionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assertions.push(Assertion.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatchAssertionsRequest {
    return {
      assertions: globalThis.Array.isArray(object?.assertions)
        ? object.assertions.map((e: any) => Assertion.fromJSON(e))
        : [],
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: LatchAssertionsRequest): unknown {
    const obj: any = {};
    if (message.assertions?.length) {
      obj.assertions = message.assertions.map((e) => Assertion.toJSON(e));
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatchAssertionsRequest>, I>>(base?: I): LatchAssertionsRequest {
    return LatchAssertionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatchAssertionsRequest>, I>>(object: I): LatchAssertionsRequest {
    const message = createBaseLatchAssertionsRequest();
    message.assertions = object.assertions?.map((e) => Assertion.fromPartial(e)) || [];
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
